module.exports = __webpack_public_path__ + "img/header_background.4a90cd48.png";